import { defineStore } from 'pinia'

type State = {
  user: UserPreview,
  authenticated: -1 | 0 | 1, // 0 = false, 1 = true, -1 = unknown
}

export const useAuthStore = defineStore('Auth', {
  state: (): State => ({
    user: {
      id: 0,
      username: '',
      role: 'Admin',
    },
    authenticated: -1,
  }),
  getters: {
    isAdmin: (state) => {
      return state.user.role === 'Admin'
    },
  },
  actions: {
    setUser (user: UserPreview) {
      this.user = user
    },
    setAuthenticated (authenticated: -1 | 0 | 1) {
      this.authenticated = authenticated
    },
    logout () {
      this.setAuthenticated(0)
      this.setUser({
        id: 0,
        username: '',
        role: 'Admin',
      })
    },
  },
})
